import type { KeyboardEvent } from 'react';
import { NavItem, ProjectAvatar } from '@frameio/vapor';
import { IconChevronRight } from '@frameio/vapor-icons';
import { useMoveToCopyToProjectRowFragment } from '../gql/generated/MoveToCopyToProjectRow';

type ProjectRowProps = {
  projectId: string;
  onSelect: () => void;
  query?: string;
};

export function ProjectRow({ projectId, onSelect, query }: ProjectRowProps) {
  const { data: project, complete } =
    useMoveToCopyToProjectRowFragment(projectId);

  if (!complete) return null;

  return (
    <NavItem
      as="button"
      data-testid={`project-nav--${project.name}`}
      highlight={query}
      iconAfter={<IconChevronRight size={16} />}
      iconBefore={
        <ProjectAvatar
          id={project.id}
          isInactive={Boolean(project.archivedAt)}
          isPrivate={project.private}
          size={AVATAR_SIZE}
          src={project.images?.image32 ?? ''}
          title={project.name}
        />
      }
      isSelected={false}
      label={project.name}
      onClick={onSelect}
      onKeyDown={(event: KeyboardEvent) => {
        if (event.key === 'Enter') {
          onSelect();
        }
      }}
      tabIndex={0}
    />
  );
}

const AVATAR_SIZE = 20;
